/**
 * BillingUserEvents
 * Registry of events for the Billing pages
 */
export enum BillingUserEvents {
    AccessFullPlatform = "Billing - Access Full Platform Link Click",
    CitationsCarouselViewAllLinkClick = "Billing - Citations Carousel - View All Link Click",
    PlanPageViewAllPlans = "Billing - Plan Page - View All Plans Link Click",
    PlanPageManageBillingLinkClick = "Billing - Plan Page - Manage Billing Link Click",
    PlanPageExplorePlansLinkClick = "Billing - Plan Page - Explore Plans Link Click",
    ProPlanButtonManagePlanLinkClick = "Billing - Pro Plan Button - Manage Plan Link Click",
    PricingPageLoginLinkClick = "Billing - Pricing Page - Login Link Click",
    PricingPageBadgeLinkClick = "Billing - Pricing Page - Badge Link Click",
    EnterpriseCTAViewDocsLinkClick = "Billing - Enterprise CTA - View Docs Link Click",
    ClickCheckoutButton = "Billing - Click Checkout Button",
    OpenEnterpriseContactModal = "Billing - Open Enterprise Contact Modal",
    PricingPageOpenEnterpriseContactModal = "Pricing - Open Enterprise Contact Modal",
    PricingPageOpenEnterpriseContactTeamModal = "Pricing - Open Enterprise Contact Team Modal",
    PricingPageClickBookACallBadge = "Pricing - Click Book A Call Badge",
    // Paywall Drawer Events
    PaywallDrawerUpgradeToProLinkClick = "Paywall Drawer - Upgrade to Pro Link Click",
    PaywallDrawerSignInLinkClick = "Paywall Drawer - Sign In Link Click",
    PaywallDrawerCloseIconClick = "Paywall Drawer - Close Icon Click",
    PaywallDrawerMaybeLaterClick = "Paywall Drawer - Maybe Later Click",
    PaywallDrawerViewCitationsLinkClick = "Paywall Drawer - View Citations Link Click",
}

/**
 * BillingApiEvents
 * Registry of server-side billing lifecycle events emitted from the Stripe
 * webhook handler. These mirror the Slack notifications sent to
 * #monitoring-stripe so the same lifecycle is queryable in PostHog.
 */
export enum BillingApiEvents {
    CheckoutStarted = "Checkout Started",
    PaymentCompleted = "Payment Completed",
    NewPlan = "Billing API - New Plan",
    SeatChange = "Billing API - Seat Change",
    TrialConverted = "Billing API - Trial Converted",
    Cancellation = "Billing API - Plan Cancelled",
}

export enum PlatformOverviewUserEvents {
    ViewDataCatalogHeroLinkClick = "Platform Overview - View Data Catalog - Hero Link Click",
    ViewDocumentationHeroLinkClick = "Platform Overview - View Documentation - Hero Link Click",
    ViewDataCatalogFooterLinkClick = "Platform Overview - View Data Catalog - Footer Link Click",
    ViewDocumentationFooterLinkClick = "Platform Overview - View Documentation - Footer Link Click",
}
